import ButtonComponent from '../../../../atoms/button/index.jsx'
import {
  buttonTypeOptions,
  buttonVariantOptions
} from '../../../../atoms/button/constants.js'
import { Settings } from '../../../../atoms/icons/core/index.js'
import { IconContainer } from '../../styled-components.js'
import colorsOptions from '../../../../fundamentals/colors-styles/constants.js'

const OrganizationalIcon = () => {
  return (
    <IconContainer>
      <ButtonComponent
        variant={buttonVariantOptions['GHOST-INVERTED']}
        buttonType={buttonTypeOptions['ICON-ONLY']}
      >
        <Settings
          style={{
            fill: colorsOptions.greys.white,
            strokeWidth: 0
          }}
        />
      </ButtonComponent>
    </IconContainer>
  )
}

export default OrganizationalIcon
